import { createSvgIcon } from "@mui/material";

export const ForgeIconLight = createSvgIcon(
  <svg viewBox="0 0 512 512" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M448.555 225.415C450.106 226.307 451.561 227.474 452.862 228.645C465.718 240.221 467.214 260.379 455.243 273.822L326.77 416.506C314.725 429.883 294.462 430.449 281.642 418.907C280.249 417.652 279.061 416.438 278.011 414.989L180.203 292.271L47.9336 207.826C46.3822 206.934 44.9887 205.823 43.6882 204.652C30.7798 193.029 29.2843 172.87 41.3287 159.494L169.802 16.8099C181.846 3.43332 202.08 2.84016 214.899 14.3827C216.2 15.5536 217.508 16.88 218.561 18.3259L306.223 128.327L332.713 98.9059C338.631 92.3335 350.075 93.0083 355.979 98.3239C361.882 103.639 362.412 113.746 356.494 120.318L330.003 149.739L448.555 225.415ZM201.825 268.184L302.916 395.028L431.389 252.344L294.673 165.065L193.582 38.222L65.1092 180.906L201.825 268.184Z"
      fill="currentColor"
    />
    <path
      d="M140.004 312.932C145.892 306.392 156.061 305.859 162.6 311.747C169.14 317.636 169.673 327.804 163.784 334.344L34.6427 476.425C28.7249 482.998 17.9498 482.925 12.0463 477.61C6.14273 472.294 5.61308 462.188 11.5309 455.616L140.004 312.932Z"
      fill="currentColor"
    />
    <path
      d="M432 134H400C391.2 134 384 126.84 384 118C384 109.16 391.2 102 400 102H432V70.0001C432 61.1561 439.2 54.0001 448 54.0001C456.8 54.0001 464 61.1561 464 70.0001V102H496C504.8 102 512 109.156 512 118C512 126.844 504.844 134 496 134H464V166C464 174.8 456.8 182 448 182C439.2 182 432 174.8 432 166V134Z"
      fill="currentColor"
    />
    <path
      d="M448 416H496C504.8 416 511.99 424.952 511.99 432.9C511.99 440.848 504.844 448 496 448H448V496C448 504.8 440.843 512 432 512C423.157 512 416 504.844 416 496V448H368C359.2 448 352.01 439.048 352.01 431.1C352.01 423.152 359.156 416 368 416H416V368C416 359.2 423.2 352 432 352C440.8 352 448 359.2 448 368V416Z"
      fill="currentColor"
    />
    <path
      d="M135 464H167V496C167 504.8 174.2 512 183 512C191.8 512 199 504.8 199 496V464H231C239.844 464 247 456.844 247 448C247 439.156 239.8 432 231 432H199V400C199 391.156 191.8 384 183 384C174.2 384 167 391.156 167 400V432H135C126.2 432 119 439.16 119 448C119 456.84 126.2 464 135 464Z"
      fill="currentColor"
    />
  </svg>,
  "ForgeIconLight",
);
